





























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { StoreModel, Store } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {storeService} from '@/shared';
import { getStoreListHeaders } from './store';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () =>
      import('@/components/common/app.grid.vue'),
    AppDialog: () =>
      import('@/components/common/app.dialog.vue'),
  },
})
export default class StoreListPage extends Base {
  public pagedStores: Store[] = [];
  public pagination = new PaginationModel('glStoreId');
  public loading: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public actions: any[] = [];
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.deleteStore();
    },
  };
  public storeToDelete: StoreModel = {};
  public searched: boolean = false;
  public deleted: boolean = false;
  public headers: VHeaders[] = getStoreListHeaders(this);

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addStore') {
      this.$router.push({ name: 'admin.stores.add.info' }).catch((ex) => {
        console.log(ex);
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('stores.btnAddStore'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('stores.btnAddStore'),
      click: 'addStore',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'stores');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t('stores.storeGridHeaders.gridAction.edit') as string,
        action: (model: StoreModel, storeid: string) => {
          return { name: 'admin.stores.edit', params: { storeId: model.id } };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t('stores.storeGridHeaders.gridAction.delete') as string,
        color: 'error',
        action: (model: StoreModel, storeid: string) => {
          this.confirmDelete(model);
        },
      },
    ];
    this.getStores();
  }
  public async getStores(): Promise<void> {
    try {
      this.loading = true;
      const response = await storeService.getStores(this.pagination);
      this.pagedStores = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public confirmDelete(item: StoreModel): void {
    this.deleteDialog.model = true;
    this.storeToDelete = item;
  }
  public async deleteStore(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await storeService.deleteStore(this.storeToDelete.id);
      this.deleted = true;
      this.showAlert(true, this.$t('stores.alertStoreDeleted'));
      this.getStores();
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }
}
